export const redirectWithQueryParams = (searchText: string, resourcePlaceIds: number[]) => {
  const params = new URLSearchParams()
  if (searchText) {
    params.append('q', searchText)
  }
  resourcePlaceIds.forEach(id => {
    params.append('account_member[resource_place_ids][]', id.toString())
  })
  const queryString = params.toString()
  const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`
  window.location.href = newUrl
}
